export default {
  networkStatus: {
    offline: 'you are working in offline mode',
    online: 'you are back online',
  },
}
